import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeRole, setActiveRole] = useState(
    localStorage.getItem("bin_role") || null
  );

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("bin_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (!activeRole || !data.roles.includes(activeRole)) {
        const fallback = data.roles[0];
        setActiveRole(fallback);
        localStorage.setItem("bin_role", fallback);
      }
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bin_token", data.token);
    setUser(data.user);
    const role = data.user.roles[0];
    setActiveRole(role);
    localStorage.setItem("bin_role", role);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("bin_token", data.token);
    setUser(data.user);
    setActiveRole("consumer");
    localStorage.setItem("bin_role", "consumer");
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("bin_token");
    localStorage.removeItem("bin_role");
    setUser(null);
    setActiveRole(null);
  };

  const switchRole = (r) => {
    setActiveRole(r);
    localStorage.setItem("bin_role", r);
  };

  return (
    <AuthCtx.Provider
      value={{ user, loading, activeRole, login, register, logout, switchRole, refresh }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
